@for (item of culturalDefinition?.author; track item; let i = $index) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Autore {{ i + 1 }}</h3>
    <dl class="sheet-facts">
      @if (item?.obj_author?.definition) {
        <div>
          <dt>Riferimento all'autore</dt>
          <dd>{{ item.obj_author.definition }}</dd>
        </div>
      }
      @if (item?.obj_intervention?.definition) {
        <div>
          <dt>Riferimento all'intervento</dt>
          <dd>{{ item.obj_intervention.definition }}</dd>
        </div>
      }
      @if (item?.attributions?.length > 0) {
        <div>
          <dt>Motivazione dell'attribuzione</dt>
          <dd>
            @for (el of item.attributions; track el; let j = $index) {
              {{ el.definition }}@if (j + 1 < item.attributions.length) {; }
            }
          </dd>
        </div>
      }
      @if (item?.chosenname) {
        <div>
          <dt>Nome scelto</dt>
          <dd>{{ item.chosenname }}</dd>
        </div>
      }
      @if (item?.personaldata) {
        <div>
          <dt>Dati personali</dt>
          <dd>{{ item.personaldata }}</dd>
        </div>
      }
      @if (item?.acronym) {
        <div>
          <dt>Acronimo</dt>
          <dd>{{ item.acronym }}</dd>
        </div>
      }
    </dl>
  </section>
}

@for (item of culturalDefinition?.scope; track item; let i = $index) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Ambito culturale {{ i + 1 }}</h3>
    <dl class="sheet-facts">
      @if (item?.obj_denomination?.definition) {
        <div>
          <dt>Denominazione</dt>
          <dd>{{ item.obj_denomination.definition }}</dd>
        </div>
      }
      @if (item?.obj_intervention?.definition) {
        <div>
          <dt>Riferimento all'intervento</dt>
          <dd>{{ item.obj_intervention.definition }}</dd>
        </div>
      }
      @if (item?.attributions?.length > 0) {
        <div>
          <dt>Motivazione dell'attribuzione</dt>
          <dd>
            @for (el of item.attributions; track el; let j = $index) {
              {{ el.definition }}@if (j + 1 < item.attributions.length) {; }
            }
          </dd>
        </div>
      }
    </dl>
  </section>
}

@if (culturalDefinition?.othersAttributions?.length > 0) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Altre attribuzioni</h3>
    <dl class="sheet-facts">
      <div>
        <dt>Attribuzioni</dt>
        <dd>
          @for (item of culturalDefinition.othersAttributions; track item; let i = $index) {
            @if (item?.attributions) {
              {{ item.attributions }}@if (i + 1 < culturalDefinition.othersAttributions.length) {; }
            }
          }
        </dd>
      </div>
    </dl>
  </section>
}

@for (item of culturalDefinition?.client; track item; let i = $index) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Committenza {{ i + 1 }}</h3>
    <dl class="sheet-facts">
      @if (item?.names?.length > 0) {
        <div>
          <dt>Nome</dt>
          <dd>
            @for (el of item.names; track el; let j = $index) {
              {{ el.name }}@if (j + 1 < item.names.length) {; }
            }
          </dd>
        </div>
      }
      @if (item?.date) {
        <div>
          <dt>Data</dt>
          <dd>{{ item.date }}</dd>
        </div>
      }
      @if (item?.circumstance) {
        <div>
          <dt>Circostanza</dt>
          <dd>{{ item.circumstance }}</dd>
        </div>
      }
      @if (item?.source) {
        <div>
          <dt>Fonte</dt>
          <dd>{{ item.source }}</dd>
        </div>
      }
    </dl>
  </section>
}
